import { provider } from "@grassrootly/api/providers";

export type GetPlayersGroupsExperiencePayload = { pid: number };
export type PlayerGroupExperience = {
  player_id: number;
  group_id: number;
  group_name: string;
  points_earned: number;
  group_logo: string | null;
};

export const GetPlayersGroupsExperience = async (
  params: GetPlayersGroupsExperiencePayload
): Promise<PlayerGroupExperience[]> => provider.Request("/players-groups-experience", params);
